import Head from "next/head";
import type { TemplateBuilderHeadType } from "@/types/templateBuilder";

// !! CAUTION !!
// <Head> is being deprecated, but the new replacement doesn't support custom <style> tags.
// As soon as it does, we should start to migrate to it.
// Currently using <Head> is our only option.
// https://beta.nextjs.org/docs/api-reference/file-conventions/head#supported-head-tags
// !! CAUTION !!

export const TemplateBuilderHead: TemplateBuilderHeadType = ({
    templateStyles,
}) => {
    return (
        <Head>
            {templateStyles.map((style) => (
                <style key={style.key}>{style.templateStyle}</style>
            ))}
        </Head>
    );
};
